import { createReducer } from '@reduxjs/toolkit';
import type { Draft } from '@reduxjs/toolkit';
import * as _ from 'lodash-es';
import type { Action } from 'redux';

import { LOAD_NOTIFICATION_SETTINGS, NOTIFICATION_SETTINGS_UPDATED } from './actions';
import type { NotificationSettingsEntry } from './types';

export interface State {
  notificationSettings: {
    [kind: number]: NotificationSettingsEntry;
  };
}

export const initialState: State = {
  notificationSettings: {},
};

type LoadNotificationSettingsAction = Action<typeof LOAD_NOTIFICATION_SETTINGS> & {
  notificationSettings: NotificationSettingsEntry[];
};
type NotificationSettingsUpdatedAction = Action<typeof NOTIFICATION_SETTINGS_UPDATED> & {
  notificationSettingsEntry: NotificationSettingsEntry;
};

const loadNotificationSettings = (
  state: Draft<State>,
  action: LoadNotificationSettingsAction
) => {
  state.notificationSettings = _.keyBy(action.notificationSettings, 'kind');
};

const updateNotificationSetting = (
  state: Draft<State>,
  action: NotificationSettingsUpdatedAction
) => {
  state.notificationSettings = {
    ...state.notificationSettings,
    [action.notificationSettingsEntry.kind]: action.notificationSettingsEntry,
  };
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(LOAD_NOTIFICATION_SETTINGS, loadNotificationSettings);
  builder.addCase(NOTIFICATION_SETTINGS_UPDATED, updateNotificationSetting);
});
